import { FC } from 'react';
import { Link, LinkProps } from '../../link/Link';
import { Breadcrumbs, BreadcrumbsProps } from '../Breadcrumbs';
import { Text } from 'components/text/Text';
import navigationBreadCrumbsStyles from './NavigationBreadcrumbs.module.css';
import { joinClassNames } from '../../../utils/joinClassNames';
import { TextProps } from '@mantine/core';

interface NavigationBreadcrumbsProps {
    items: { label: string; href: string; target?: string }[];
    currentHref: string;
    breadCrumbProps?: BreadcrumbsProps;
    linkProps?: LinkProps;
    currentHrefTextProps?: TextProps;
}

export const NavigationBreadcrumbs: FC<NavigationBreadcrumbsProps> = ({
    items,
    currentHref,
    breadCrumbProps,
    linkProps: { className: linkClassName, ...restLinkProps } = {},
    currentHrefTextProps: { className: currentHrefTextClassName, ...restCurrentHrefProps } = {},
}) => {
    return (
        <Breadcrumbs {...breadCrumbProps}>
            {items.map((item, index) => {
                if (item.href === currentHref) {
                    return (
                        <Text
                            key={index}
                            className={joinClassNames(
                                navigationBreadCrumbsStyles.currentHrefText,
                                currentHrefTextClassName
                            )}
                            {...restCurrentHrefProps}
                        >
                            {item.label}
                        </Text>
                    );
                }
                return (
                    <Link
                        key={index}
                        href={item.href}
                        target={item.target}
                        className={joinClassNames(navigationBreadCrumbsStyles.linkText, linkClassName)}
                        {...restLinkProps}
                    >
                        {item.label}
                    </Link>
                );
            })}
        </Breadcrumbs>
    );
};
